import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { createDialog } from '@patsnap/tahiti-core';
import type {
    CommandContribution,
    CommandRegistry,
} from '@patsnap/tahiti-core';
import type {
    PaymentSuccessDialogOptions,
    PaymentSuccessDialogResult,
} from '../../components/PaymentSuccessDialog.vue';

// Re-export types for external use
export type { PaymentSuccessDialogOptions, PaymentSuccessDialogResult };

/**
 * PaymentSuccess 对话框服务工厂
 */
const paymentSuccessDialogServiceFactory = createDialog(() => import('../../components/PaymentSuccessDialog.vue'));

/**
 * PaymentSuccess 对话框命令处理器
 */
@injectable()
export class PaymentSuccessDialogCommandHandler implements CommandContribution {
    private _dialogService = paymentSuccessDialogServiceFactory();

    /**
     * 处理打开 PaymentSuccess 对话框命令
     */
    private async _handleOpenPaymentSuccessDialog(payload?: {
        title?: string;
    }): Promise<PaymentSuccessDialogResult> {
        return new Promise((resolve) => {
            const dialog = this._dialogService;

            dialog.onSubmit(async (result, next) => {
                console.log('PaymentSuccess dialog submitted:', result);
                resolve(result);
                next();
            });

            dialog.onCancel(() => {
                const result: PaymentSuccessDialogResult = {
                    action: 'close',
                };
                resolve(result);
            });

            dialog.open({
                title: payload?.title,
                width: '600px',
                height: 'auto',
            });
        });
    }

    /**
     * 注册命令
     */
    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand({
            id: 'plg:open-payment-success-dialog',
        }, {
            execute: (payload?: {
                title?: string;
            }) => {
                return this._handleOpenPaymentSuccessDialog(payload);
            },
        });
    }
}

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 打开支付成功对话框
         * @param commandId - 命令 ID
         * @param params - 参数
         */
        executeCommand(commandId: 'plg:open-payment-success-dialog', params?: {
            title?: string;
        }): Promise<PaymentSuccessDialogResult>;
    }
}
